/** Каталог якорей страницы «Настройки портала» */
export const SETTINGS_ANCHORS = {
  toolbar: {
    /** Одна и та же метка у кнопки в тулбаре и у кнопки внизу формы на мобильной ширине */
    save: 'settings.toolbar.save',
    importNorms: 'settings.toolbar.importNorms',
    importLocations: 'settings.toolbar.importLocations',
  },
  tabs: {
    organization: 'settings.tabs.organization',
    structure: 'settings.tabs.structure',
    branding: 'settings.tabs.branding',
    integrations: 'settings.tabs.integrations',
  },
  organization: {
    /* Реквизиты для согласия на обработку ПД: рамка от полного наименования до юридического адреса */
    requisitesFirst: 'settings.organization.requisitesFirst',
    requisitesLast: 'settings.organization.requisitesLast',
    email: 'settings.organization.email',
    /** Разделитель «Документы»; рамка всего блока — от него до `agreementLast` */
    documentsFirst: 'settings.organization.documentsFirst',
    consent: 'settings.organization.consent',
    /* Соглашение: рамка от заголовка со статусом до кнопки прикрепления и списка файлов */
    agreementFirst: 'settings.organization.agreementFirst',
    agreementLast: 'settings.organization.agreementLast',
  },
} as const

/** Имена контекстов модуля */
export const SETTINGS_CONTEXTS = {
  page: 'settings.page',
} as const
